import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { SideDrawerForm } from '@sales-center/components'
import { ImportTypeSelect } from './Fields/ImportTypeSelect'
import { ImportUtilityContent } from './ImportUtilityContent'
import { NameAndDescription } from './Fields/NameAndDescription'
import { TemplateDownloadSection } from './Fields/TemplateDownloadSection'
import { useHandlers } from './hooks/useHandlers'

type Props = {
  onClose: () => void
}

export function AddImportUtilityForm(props: Props) {
  const { onClose } = props
  const { handleSave, isSubmitting } = useHandlers(onClose)

  return (
    <SideDrawerForm
      tidalThemeActive={true}
      onSave={handleSave}
      primaryBtnLabel="Next"
      disableSave={isSubmitting}
      cancelBtnVariant="text"
      onCancel={onClose}
      containerStyle={{
        px: 2,
      }}
    >
      <Typography variant="subtitle1" sx={{ mb: 1.6 }}>
        To import records, make selections below then click next to upload the
        file.
      </Typography>
      <Box>
        <ImportTypeSelect />
        <TemplateDownloadSection />
        <NameAndDescription />
        <ImportUtilityContent />
      </Box>
    </SideDrawerForm>
  )
}
